import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/constants/site";

const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20stylish%20streetwear%20fashion%20products%20including%20white%20sneakers%20a%20folded%20mint%20green%20hoodie%20a%20tan%20leather%20handbag%20and%20a%20minimalist%20watch%20arranged%20neatly%20on%20a%20clean%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20aesthetic%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=1600&height=900&seq=basetao-hero-01&orientation=landscape";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[540px] items-center justify-center overflow-hidden md:min-h-[640px]">
      <img
        src={HERO_IMAGE}
        alt="Basetao spreadsheet fashion products flat lay"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/55 to-background-50/85" />

      <div className="relative z-10 mx-auto w-full max-w-3xl px-4 py-16 text-center md:px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-700 md:text-sm">
          {t("hero.eyebrow")}
        </p>
        <h1 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-foreground-950 md:text-5xl">
          {t("hero.title")}
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          {t("hero.subtitle")}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-external-link-line flex h-4 w-4 items-center justify-center text-base leading-none" />
            {t("hero.primaryCta")}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:w-auto"
          >
            <i className="ri-shopping-bag-line flex h-4 w-4 items-center justify-center text-base leading-none" />
            {t("hero.secondaryCta")}
          </a>
        </div>

        <p className="mt-6 text-xs text-foreground-500 md:text-sm">{t("hero.trust")}</p>
      </div>
    </section>
  );
}